import { InMemoryWebStorage, WebStorageStateStore } from 'oidc-client-ts';

const OidcConfig = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_OIDC_SIGNIN_REDIRECT_URI,
  popup_post_logout_redirect_uri: import.meta.env.VITE_OIDC_SIGNOUT_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid profile',
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),
  onSigninCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  onSignoutCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export default OidcConfig;
